import { AjaxGetAndReplaceHtml } from "../../shared/ajaxGetAndReplaceHtml";
import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { CookieUtils } from "../../shared/utilities/cookieUtils";
import { CookieEnums } from "../../shared/utilities/enums/cookieEnums";
import { CustomEventEnums } from "../../shared/utilities/enums/customEventEnums";
import { UrlEnums } from "../../shared/utilities/enums/urlEnums";

const urlPaths = require('../../config/urlPaths.json');

export interface IBasketSimple extends IInstanceComponentBase {

}

export class BasketSimple extends InstanceComponentBase implements IBasketSimple {
    private readonly _updateSimpleBasket;
    public basketSessionId: string;

    constructor(htmlElement: Element) {
        super(htmlElement);

        this.basketSessionId = CookieUtils.getCookie(CookieEnums.BasketSessionId);

        this._updateSimpleBasket = this.updateSimpleBasket.bind(this);

        this._updateSimpleBasket();

        this.attachAddProductCompletedEventListener();
        this.attachBasketLineUpdatedEventListener();
        this.attachBasketLineDeletedEventListener();
    }

    attachAddProductCompletedEventListener(): void {
        document.addEventListener(CustomEventEnums.AddProductCompleted, this._updateSimpleBasket);
    }
    attachBasketLineUpdatedEventListener(): void {
        document.addEventListener(CustomEventEnums.BasketLineUpdated, this._updateSimpleBasket);
    }
    attachBasketLineDeletedEventListener(): void {
        document.addEventListener(CustomEventEnums.BasketLineDeleted, this._updateSimpleBasket);
    }
    removeAddProductCompletedEventListener(): void {
        document.removeEventListener(CustomEventEnums.AddProductCompleted, this._updateSimpleBasket);
    }
    removeBasketLineUpdatedEventListener(): void {
        document.removeEventListener(CustomEventEnums.BasketLineUpdated, this._updateSimpleBasket);
    }
    removeBasketLineDeletedEventListener(): void {
        document.removeEventListener(CustomEventEnums.BasketLineDeleted, this._updateSimpleBasket);
    }

    async getSimpleBasket() {
        console.log("BasketSimple: getSimpleBasket");
        if ((this.basketSessionId !== null) && (this.basketSessionId.length > 0)) {
            console.log("BasketSimple: getSimpleBasket start");
            let basketSummaryElement = this.htmlElement;
            const uriSummary = urlPaths.websiteUrl + UrlEnums.PartialUrls.BasketSimple + this.basketSessionId;
            await AjaxGetAndReplaceHtml(basketSummaryElement, uriSummary);
            console.log("BasketSimple: getSimpleBasket end");
        }
    }
    async updateSimpleBasket(): Promise<void> {
        await this.getSimpleBasket();
    }

    dispose(): void {
        this.removeAddProductCompletedEventListener();
        this.removeBasketLineUpdatedEventListener();
        this.removeBasketLineDeletedEventListener();
    }

}